import React, { useContext, useEffect, useState } from 'react';
import { classes, TestIdIdentifier } from '../../../../util/identifiers/identifiers.util';
import { handleKeyEvent } from '../../../../util/events.util';
import Tooltip from '../../../../ui/pages/Common/Tooltip';
import { CompanyContext } from '../../../../context/CompanyContext';
import { Colors, VentoryColor } from '../../../util/color.util';
import CheckIcon from '../../../icons/Check/CheckIcon';

interface CheckboxInputProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  disabled?: boolean;
  dynamicUpdate?: boolean;
  testId?: TestIdIdentifier;
  tooltip?: string | JSX.Element;
  subText?: string;
}

export default function Checkbox({
  value,
  onChange,
  label,
  disabled = false,
  tooltip,
  testId,
  subText,
}: CheckboxInputProps) {
  const { currentCompany } = useContext(CompanyContext);

  const [checked, setChecked] = useState<boolean>(value);

  const handleChange = () => {
    if (disabled) return;
    setChecked(!checked);
    onChange(!checked);
  };

  useEffect(() => {
    setChecked(value);
  }, [value]);

  return (
    <div
      className={`grid cursor-pointer select-none ${
        label || subText || tooltip ? 'grid-cols-[auto_1fr]' : ''
      } items-start justify-center`}
      onClick={event => {
        event.stopPropagation();
        handleChange();
      }}
    >
      <div className='relative h-[20px] w-[20px] '>
        <input
          data-testid={testId?.name}
          readOnly
          disabled={disabled}
          checked={checked}
          type='checkbox'
          name='bordered-checkbox'
          tabIndex={0}
          onKeyDown={event => handleKeyEvent(event, 'Enter', handleChange)}
          style={{
            appearance: 'none',
            cursor: disabled ? 'not-allowed' : 'pointer',
            backgroundColor: disabled
              ? VentoryColor.grey200
              : checked
              ? Colors.companyLightBackground(currentCompany)
              : 'white',
            borderColor: checked && !disabled ? Colors.companyDarkText(currentCompany) : VentoryColor.grey300,
          }}
          className={`${classes.checkbox.name} ventory-border-color align-start h-[20px] w-[20px] cursor-pointer  rounded-3 border`}
        />
        {checked ? (
          <CheckIcon
            className='absolute bottom-[5px] left-[4px]'
            color={disabled ? VentoryColor.grey400 : Colors.companyDarkText(currentCompany)}
          />
        ) : null}
      </div>
      <div className='overflow-hidden pl-2'>
        <div className='flex gap-x-1'>
          {label ? (
            <p title={label} className='overflow-hidden overflow-ellipsis whitespace-nowrap text-sm'>
              {label}
            </p>
          ) : null}
          {tooltip ? <Tooltip element={tooltip} /> : null}
        </div>
        {subText ? (
          <p
            title={subText}
            className='overflow-hidden overflow-ellipsis whitespace-nowrap text-[12px] font-[400] text-gray-300'
          >
            {subText}
          </p>
        ) : null}
      </div>
    </div>
  );
}
